export default "__VITE_ASSET__C$FRf4RF__"